import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
// import { ToastContext } from "src/context/toastContext";

// import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseListingType, RenderNextStepProps, statetype } from "./types";
import { PrecertAPIResponse } from "../precert/types";
// import { LoaderContext } from "src/context/loaderContext";
// import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { isMobileOrTablet } from "src/helpers";


const RenderNextStep: FC<RenderNextStepProps> = ({ kase, showHideModalForTreatment }): JSX.Element => {
  // const { showToast } = useContext(ToastContext);
  // const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()
  // const { submiAppealForCase, apiInPorgress } = useAppealButtonFunc();


  // const buyAndBillButton = (caseID:number) => {
  //   updateCaseMutate({case:{status_name:"Pulled From Stock",color_idx:3}},{caseId:caseID},{})
  //   getCaseListing()
  // }

  const { data: updateCaseResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_CASES, {}, {}, false);

  useEffect(() => {
    if (updateCaseResponse) {
      navigate(`/cases`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCaseResponse]);


  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  const navigateToPrecertForm = (caseId: number, precertId: number) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams)
  }

  // const navigateToReviewPrecertForm = (caseId: number, precertId: number) => {
  //   navigate(`/cases/${caseId}/precerts/${precertId}/review`);
  // }


  // const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
  //   useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.id });

  // useEffect(() => {
  //   if (transferRxData) {
  //     const { message } = transferRxData as unknown as { code: number; message: string; };
  //     showToast([message], ToastTypes.SUCCESS);
  //     getCaseListing();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxData]);

  // useEffect(() => {
  //   if (transferRxLoading) setLoader();
  //   else hideLoader();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxLoading]);

  // const ConfirmAlert = (caseID:number) => {

  //   const result = window.confirm('Are you sure you want to release this prescription to the specialty pharmacy for processing?');
  //   if (result) {

  //     transferRxByCaseId({case_id:caseID},{case_id:caseID})

  //   }
  // };
  const naviagteToRX_PA = (kase: CaseListingType) => {
    navigate(`/cases/${kase.id}/document/new?precert_id=${kase.active_pa_id}&insuranceName=${kase.primary_insurance}`)
  }



  const caseAction = [];


  if (kase.active_pa) {
    caseAction.push(
      // <button
      //   className="btn btn-success m-1 text-white"
      //   //disabled = {!kase.transfer_to_rx}
      //   onClick={() =>  
      //     //navigateToPrecertForm(kase.id, kase.active_pa_id)
      //     naviagteToRX_PA(kase)

      //   }
      //     title='Clicking "Prior Authorization" allows you to upload clinicals and enter information for the precert as well as submit it to the plan or request it be completed on your behalf.'

      // >
      //   <i className="fa fa-clipboard"></i> Rx PA
      // </button>
      <>
        <OverlayTrigger
          placement="top"
          trigger={['click']}
          overlay={
            <Tooltip id={`rx-pa-tooltip-${kase?.id}`}>
              Clicking "Prior Authorization" allows you to upload clinicals and enter
              information for the precert as well as submit it to the plan or request
              it be completed on your behalf.
            </Tooltip>
          }
        >
          <span
            className="me-1"
            style={{ cursor: 'pointer', display: 'inline-block' }}
            tabIndex={0}
          >
           <i className="fa fa-info-circle"></i>
          </span>
        </OverlayTrigger>

        <button
          className="btn btn-success m-1 text-white"
          onClick={() => naviagteToRX_PA(kase)}
        >
          <i className="fa fa-clipboard"></i> Rx PA
        </button>
      </>
    )
  }
  if (caseAction.length === 0) {
    caseAction.push(<p className="fs-6 mb-0">No Action Required</p>);

  }

  return (
    <>
      {caseAction}
    </>
  );
};

export default RenderNextStep;
